import { wellnub } from '../wellnub.api';

export const requestFileUpload = async payload => {
  const { data } = await wellnub.post(
    '/v1/nutritionist/file/nutritionPlan',
    payload,
  );
  return data;
};
